// update along with app/lib/enums/user_permission.py
const UserPermission = {
  ASSIGN_USER_ROLE: 'assign_user_role',
  BRAND_HARVESTING: 'brand_harvesting',
  CLASSIFY: 'classify',
  CONFLICT_RESOLVE: 'conflict_resolve',
  CONVERT_MANUFACTURER_PRODUCTS: 'convert_manufacturer_products',
  CREATE_EDIT_ROLE: 'create_edit_role',
  DATA_SYNC: 'data_sync',
  EDIT_ATTRIBUTES: 'edit_attributes',
  EDIT_PRODUCT: 'edit_product',
  ENRICH_PRODUCTS: 'enrich_products',
  MANAGE_ACTIVITY_LOGS: 'manage_activity_logs',
  MANAGE_ASSETS: 'manage_assets',
  MANAGE_DATA_SOURCES: 'manage_data_sources',
  MANAGE_DATA_STREAMS: 'manage_data_streams',
  MANAGE_PRODUCT_LISTS: 'manage_product_lists',
  MANAGE_TAXONOMY: 'manage_taxonomy',
  MANAGE_USERS: 'manage_users',
  TASKS_VIEW: 'view_tasks',
  UNCLASSIFY: 'unclassify',
  UPB_SCORE_VIEW: 'upb_score_view',
  UPB_VIEW: 'upb_view',
  UPB_VIEW_ADMIN: 'upb_view_admin',
  UPB_SALES_VIEW: 'upb_sales_view',
  VIEW_CATEGORY_CONFLICTS: 'view_category_conflicts',
  VIEW_CONFLICTS: 'view_conflicts',
  VIEW_DASHBOARD: 'view_dashboard',
  VIEW_FILE_EXPORTS: 'view_file_exports',
  VIEW_PRODUCT_LISTS: 'view_product_lists',
  VIEW_SKU_MAPPINGS: 'view_sku_mappings',
  VIEW_USER_MANAGEMENT: 'view_user_management',
  VIEW_BRAND_QA_AI_SUGGESTIONS: 'view_brand_qa_ai_suggestions',
  DATA_SOURCE_CONTENT_VERIFICATION: 'data_source_content_verification',
  ADMIN_OPERATIONS: 'admin_operations',
  VIEW_UPB_SCORE: 'upb_score_view',
  ASSIGN_THUMBNAILS: 'assign_thumbnails',
  REVIEW_ASSIGNED_THUMBNAILS: 'review_assigned_thumbnails',
  REVIEW_AI_SUGGESTED_THUMBNAILS: 'review_ai_suggested_thumbnails',
  MANAGE_SUPPORT_TICKETS: 'manage_support_tickets',
  MANAGE_PAYMENTS: 'manage_payments',
  CLEANUP_BRANDS: 'cleanup_brands',
  VIEW_JOBS: 'view_jobs',
  MANAGE_JOBS: 'manage_jobs',
  VIEW_DATA_REPORTS: 'view_data_reports',
  EXPORT_PRODUCT_DATA: 'export_product_data',
};

export default UserPermission;
